// Type for YAML-based job post links
export interface YamlJobPostLink {
  id: string;
  title: string;
  url: string;
  description: string;
  ogp?: any;
}

export default class JobPostLink {
  id: string;
  title: string;
  url: string;
  description: string;
  ogp: any;

  constructor(link: YamlJobPostLink) {
    this.id = link.id;
    this.title = link.title!;
    this.url = link.url!;
    this.description = link.description!;
    this.ogp = link.ogp as any;
  }
}
